import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';
import { GlobalSearchDialogComponent } from 'src/app/components/utility/global-search-dialog/global-search-dialog.component';
import { GlobalSearchInputComponent } from 'src/app/components/utility/global-search-input/global-search-input.component';
import { SearchResultComponent } from 'src/app/components/utility/search-result/search-result.component';
import { NoDataComponent } from 'src/app/components/utility/no-data/no-data.component';
import { ServicesIconSvgComponent } from 'src/app/components/layout/svg/services-icon-svg.component';
import { SchemeIconSvgComponent } from 'src/app/components/layout/svg/scheme-icon-svg.component';
import { UmangLogoSvgComponent } from 'src/app/components/layout/svg/umang-logo-svg.component';
import { DocumentsIconSvgComponent } from '../../components/layout/svg/documents-icon-svg.component';

const globalSearchRoutes: Routes = [
  { path: '', component: GlobalSearchDialogComponent },
  { path: 'search-result', component: SearchResultComponent },
];

@NgModule({
  declarations: [
    GlobalSearchDialogComponent,
    GlobalSearchInputComponent,
    SearchResultComponent,
    NoDataComponent,
  ],
  imports: [
    RouterModule.forChild(globalSearchRoutes),
    CommonModule,
    SharedModule,
    ServicesIconSvgComponent,
    SchemeIconSvgComponent,
    UmangLogoSvgComponent,
    DocumentsIconSvgComponent,
  ],
})
export class GlobalSearchModule {}
